import { categories } from '../../../data/categories';

interface PostsFilterProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
  totalCount: number;
}

export function PostsFilter({ activeCategory, onCategoryChange, totalCount }: PostsFilterProps) {
  return (
    <div className="py-5 border-b border-[#E8E0D5]">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-2 flex-wrap">
          <button
            onClick={() => onCategoryChange('all')}
            className={`px-3 py-1.5 text-xs rounded-full border transition-colors cursor-pointer whitespace-nowrap ${
              activeCategory === 'all'
                ? 'bg-[#2C2416] text-[#FDFAF6] border-[#2C2416] font-semibold'
                : 'text-[#7A6E62] border-[#D4C9BE] hover:border-[#2C2416] hover:text-[#2C2416]'
            }`}
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            すべて
          </button>
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => onCategoryChange(cat.slug)}
              className={`px-3 py-1.5 text-xs rounded-full border transition-colors cursor-pointer whitespace-nowrap ${
                activeCategory === cat.slug
                  ? 'bg-[#5B7B6F] text-white border-[#5B7B6F] font-semibold'
                  : 'text-[#7A6E62] border-[#D4C9BE] hover:border-[#5B7B6F] hover:text-[#5B7B6F]'
              }`}
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              {cat.name}
            </button>
          ))}
          <span
            className="ml-auto text-xs text-[#9A8E84] whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            {totalCount}件
          </span>
        </div>
      </div>
    </div>
  );
}
